/** The local player is always shown in the "mine" colour, everywhere (avatars, map, feed). */
export const MY_COLOR = '#b6ff3b';

export function colorFor(user: { id: string; color: string } | null | undefined, myId: string | null | undefined): string {
  if (!user) return '#9aabbd';
  return user.id === myId ? MY_COLOR : user.color;
}
